// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"906ef4d7","239":"47b2b5ca","453":"c18864c9","732":"26557319"}[chunkId] + ".chunk.js";
};